export enum WorkflowDetailType {
  Workflow,
  Booking
}
